// ============================================================================
// CANCUN100 — RepartoMargen.js  (Bloque 26: reparto libre y simétrico del margen en + Reserva (admin))
// ----------------------------------------------------------------------------
// Cuadro doble [ Casa __ % ] ↔ [ Vendedor __ % ]: al escribir en uno, el otro se autorrellena con 100 − valor.
// Atajos: 100 casa · 80 / 20 · 100 vendedor. Vista previa con los montos. Preparado para crecer a más partes
// (PARTES es un arreglo; hoy solo casa y vendedor), p. ej. supervisor más adelante.
// Nada funcional de Sala/Top Tours: solo el canal admin.
// ============================================================================
import React from 'react';
import { RADIO, RADIO_TARJETA } from './tema';
import Stepper from './Stepper'; // APP 2/05 · F1

export const PARTES = [
  { clave: 'casa', etiqueta: 'Casa' },
  { clave: 'vendedor', etiqueta: 'Vendedor' },
];
export const ATAJOS = [
  { etiqueta: '100 casa', vendedor: 0 },
  { etiqueta: '80 / 20', vendedor: 80 },
  { etiqueta: '100 vendedor', vendedor: 100 },
];
const F = new Intl.NumberFormat('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const acotar = (v) => { const n = Math.round(Number(v)); return Number.isFinite(n) ? Math.max(0, Math.min(100, n)) : 0; };

// pctVendedor: 0–100 (entero). onChange(pctVendedor). margen: número para la vista previa.
export default function RepartoMargen({ C, pctVendedor, onChange, margen = 0, deshabilitado = false, nota }) {
  const pv = acotar(pctVendedor);
  const valores = { casa: 100 - pv, vendedor: pv };
  const montos = { casa: Math.round(Math.max(0, margen) * (100 - pv)) / 100, vendedor: Math.round(Math.max(0, margen) * pv) / 100 };
  const poner = (clave, v) => {
    if (deshabilitado) return;
    const n = acotar(v);
    onChange(clave === 'vendedor' ? n : 100 - n); // simétrico: el otro cuadro queda en 100 − valor
  };
  return (
    <div>
      <div style={{ fontSize: 14, fontWeight: 600, color: C.muted, marginBottom: 6 }}>Reparto del margen{deshabilitado ? ' (congelado en el folio)' : ''}</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: 10, alignItems: 'end' }}>
        {PARTES.map((p, i) => (
          <React.Fragment key={p.clave}>
            {i > 0 && <div aria-hidden="true" style={{ fontSize: 22, color: C.muted, paddingBottom: 9 }}>↔</div>}
            <label style={{ display: 'block' }}>
              <span style={{ display: 'block', fontSize: 12, color: C.muted, marginBottom: 4 }}>{p.etiqueta}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: 6, opacity: deshabilitado ? 0.6 : 1 }}>
                {/* APP 2/05 · F1: Stepper − n + (por ciento) */}
                <Stepper chico value={valores[p.clave]} min={0} max={100} disabled={deshabilitado} label={`${p.etiqueta} por ciento`} onChange={(n) => poner(p.clave, String(n))} />
                <span style={{ fontSize: 14, color: C.muted }}>%</span>
              </div>
            </label>
          </React.Fragment>
        ))}
      </div>
      {!deshabilitado && (
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
          {ATAJOS.map((a) => (
            <button key={a.etiqueta} type="button" onClick={() => onChange(a.vendedor)} aria-pressed={pv === a.vendedor}
              style={{ height: 32, boxSizing: 'border-box', padding: '0 12px', borderRadius: RADIO, fontSize: 12, fontWeight: 600, cursor: 'pointer', fontFamily: 'var(--au-font-text)', border: `1px solid ${pv === a.vendedor ? 'transparent' : C.border}`, background: pv === a.vendedor ? 'var(--equipo-grad)' : 'transparent', color: pv === a.vendedor ? '#fff' : C.muted }}>
              {a.etiqueta}
            </button>
          ))}
        </div>
      )}
      <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>El margen (venta − neto) se reparte entre casa y vendedor según estos porcentajes.</div>
      <div style={{ marginTop: 8, padding: '8px 12px', borderRadius: RADIO_TARJETA, background: `${C.green}10`, border: `1px solid ${C.green}33`, fontSize: 12, color: C.text, fontFamily: 'var(--au-font-text)' }}>
        Margen <strong>${F.format(Math.max(0, margen))}</strong> · Casa <strong>${F.format(montos.casa)}</strong> · Vendedor <strong>${F.format(montos.vendedor)}</strong>
      </div>
      {nota && <div style={{ fontSize: 12, color: C.muted, marginTop: 6 }}>{nota}</div>}
    </div>
  );
}
